export function truncate (string, value) {
	if (string.length < value) {
		return string;
	}
	return string.substring(0, value).trim() + '…';
}


// WEBPACK FOOTER //
// ./src/shared/helper.js